import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'focused-item':_ctx.focused}, 'merge-button-container'])
  }, [
    _createVNode(_component_el_tooltip, {
      placement: "top-start",
      content: _ctx.tooltipContent,
      "show-after": 5
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          id: "merge-segments",
          class: _normalizeClass(['img-button-container', 'merge-button', { 'disabled': _ctx.disabled }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mergeSegment && _ctx.mergeSegment(...args)))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", { class: "material-symbols-outlined" }, " compress ", -1)
        ]))], 2)
      ]),
      _: 1
    }, 8, ["content"])
  ], 2))
}